<template>
    <b-container>
        <b-row>
            <b-col></b-col>
            <b-col>
                <b-form novalidate>
                    <b-card border-variant="secondary"
                            header-bg-variant="primary"
                            header-text-variant="secondary-light"
                            :header="$t('profile.title')"
                            class="text-center lead">
                        <b-form-group style="margin-bottom: 0.3rem">
                            <label class="float-left">{{ $t('profile.language') }}</label>
                        </b-form-group>
                        <b-form-group>
                            <multiselect
                                v-model="userProfile.language"
                                :options="languageOptions"
                                track-by="label"
                                :searchable="false"
                                select-label=""
                                deselect-label=""
                                selected-label=""
                                placeholder="">
                                <template slot="option" slot-scope="props">
                                    <span :class="props.option.cssClass"></span>&nbsp;
                                    <span>{{ props.option.label }}</span>
                                </template>
                                <template slot="singleLabel" slot-scope="props">
                                    <span :class="props.option.cssClass"></span>&nbsp;
                                    <span>{{ props.option.label }}</span>
                                </template>
                            </multiselect>
                        </b-form-group>
                        <b-form-group>
                            <label for="firstName" class="float-left">{{ $t('profile.firstName') }}</label>
                            <b-form-input
                                id="firstName"
                                type="text"
                                v-model="userProfile.firstName"
                                :disabled="true">
                            </b-form-input>
                        </b-form-group>
                        <b-form-group>
                            <label for="lastName" class="float-left">{{ $t('profile.lastName') }}</label>
                            <b-form-input
                                id="lastName"
                                type="text"
                                v-model="userProfile.lastName"
                                :disabled="true">
                            </b-form-input>
                        </b-form-group>
                        <b-form-group>
                            <label for="email" class="float-left">{{ $t('profile.email') }}</label>
                            <b-form-input
                                id="email"
                                type="text"
                                name="userEmail"
                                v-validate="'required|email'"
                                v-model="userProfile.email"
                                :state="!veeErrors.has('userEmail')"
                                :disabled="true">
                            </b-form-input>
                            <span v-show="veeErrors.has('userEmail')" style="color: red;" class="small">{{ $t('profile.messages.validation.email') }}</span>
                        </b-form-group>
                        <hr>
                        <b-button type="button" class="float-right btn-primary" @click="saveChanges()">{{ $t('profile.saveChanges') }}</b-button>
                    </b-card>
                </b-form>
            </b-col>
            <b-col></b-col>
        </b-row>
    </b-container>
</template>

<script>
import { mapGetters } from 'vuex';
import Multiselect from 'vue-multiselect';

export default {
    name: 'user-profile',

    components: { Multiselect },

    data() {
        return {
            userProfile: {
                language: null,
                firstName: '',
                lastName: '',
                email: ''
            },

            languageOptions: [
                { label: '', value: null },
                { label: 'English', value: 'en', cssClass: 'flag-icon flag-icon-gb' },
                { label: 'Deutsch', value: 'de', cssClass: 'flag-icon flag-icon-de' }
            ],

            currentLanguage: this.$store.getters['userData/language']
        }
    },

    mounted() {
        if (this.userData) {
            this.userProfile.firstName = this.userData.firstName;
            this.userProfile.lastName = this.userData.lastName;
            this.userProfile.email = this.userData.email;

            let langOption = this.languageOptions.find(opt => opt.value === this.userData.language);
            if (langOption) {
                this.userProfile.language = langOption;
            }
        }
    },

    computed: {
        ...mapGetters({
            userData: 'userData/userData'
        })
    },

    watch: {
        currentLanguage(newVal) {
            this.$i18n.locale = newVal;
        }
    },

    methods: {
        saveChanges() {
            this.$validator.validateAll()
                .then((result) => {
                    if(result) {
                        this.$store.dispatch('userData/setLanguage', this.userProfile.language.value);

                        this.$store.dispatch('userData/updateMe', {
                            firstName: this.userProfile.firstName,
                            lastName: this.userProfile.lastName,
                            email: this.userProfile.email,
                            language: this.userProfile.language.value
                        });
                    }
                });
        }
    }
}
</script>

<style>
</style>
